module.exports = __webpack_public_path__ + "static/pipes_of_haunting-ea95bdd460de20f7eaab488be4f07bb9.jpeg";